import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Button, Col,  Form,  Input,  Row, Select} from 'antd';
import { SPAN_FULL, SPAN_ONE_THIRD, MARGIN_SM, MARGIN_MD } from '../../../../../../../styles/constants';
import { showFileMappingWizardAddFieldFunctionReplaceFormChange, onClearReplace } from '../../actions';
import _ from "lodash";

const mapStateToProps = state => ({
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
  ReplaceFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.ReplaceFormData
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(showFileMappingWizardAddFieldFunctionReplaceFormChange(fields)),
  onClearReplace: () => dispatch(onClearReplace()),
});

const mapPropsToFields = ({ReplaceFormData}) => ({
  selectValue: Form.createFormField({value: ReplaceFormData !== null ? ReplaceFormData.selectValue : null}),
  replaceValue: Form.createFormField({value: ReplaceFormData !== null ? ReplaceFormData.replaceValue : null}),
  withValue: Form.createFormField({value: ReplaceFormData !== null ? ReplaceFormData.withValue : null}),
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardReplaceWizard = ({
                                                t,
                                                form,
                                                mergedHeader,
                                                onClearReplace
                                              }) => {
                          
  return (
    
    <Fragment>
        <Col span={SPAN_FULL}>
          <Row type='flex' justify='space-between'>
            <Col span={SPAN_ONE_THIRD}>
              <Form.Item
                className="form-item"
                label={t('data.fileMapping.addField.functionWizard.field.label')}
              >
                {form.getFieldDecorator("selectValue")(
                  <Select
                    title={form.getFieldValue("selectValue")}
                    >
                    {mergedHeader.map((field) => (
                      <Select.Option
                        key={field.name}
                        value={field.name}
                        title={`${field.name}`}
                      >
                        {field.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={13}>
              <Row type='flex'>
                <Form.Item
                  className='form-item'
                  label={t('data.fileMapping.addField.functionWizard.replace.label')}
                  style={{marginRight: MARGIN_SM}}
                  >
                    {form.getFieldDecorator("replaceValue")(
                      <Input
                        title={form.getFieldValue("replaceValue")}
                        style={{
                          width: 100
                        }}
                      />
                    )}
                </Form.Item>
                <Form.Item
                  className='form-item'
                  label={t('data.fileMapping.addField.functionWizard.with.label')}
                  >
                    {form.getFieldDecorator("withValue")(
                      <Input
                        title={form.getFieldValue("withValue")}
                        style={{
                          width: 100,
                          marginLeft: {MARGIN_MD}
                        }}
                      />
                    )}
                </Form.Item>
              </Row>
            </Col>
            <Col>
              <Button
                onClick={onClearReplace}
                icon="delete"
              >
              </Button>
            </Col>
          </Row>
        </Col>
    </Fragment>
);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
  )(FileMappingWizardReplaceWizard);